import { create } from 'zustand';
import { supabase, Simulation } from './supabase';

interface SimulationStore {
    simulations: Simulation[];
    isLoading: boolean;
    error: string | null;

    activeSimulation: Simulation | null;
    setActiveSimulation: (sim: Simulation | null) => void;

    fetchUserSimulations: (institutionId: string) => Promise<void>;
}

export const useSimulationStore = create<SimulationStore>((set) => ({
    simulations: [],
    activeSimulation: null,
    isLoading: false,
    error: null,

    setActiveSimulation: (sim) => set({ activeSimulation: sim }),

    fetchUserSimulations: async (institutionId: string) => {
        set({ isLoading: true, error: null });
        try {
            if (!supabase) throw new Error('Supabase client not initialized');

            const { data, error } = await supabase
                .from('simulations')
                .select('*')
                .eq('institution_id', institutionId)
                .eq('is_active', true)
                .order('created_at', { ascending: false });

            if (error) throw error;
            set({ simulations: data || [] });
        } catch (error: any) {
            set({ error: error.message });
        } finally {
            set({ isLoading: false });
        }
    }
}));
